import { getCoachLayouts } from "../../../../app/api/getPlaceMap";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

class GetCoachLayoutAction extends BaseAction<{ coachLayoutResponseData: any }, string> {

    override async run(): Promise<{ coachLayoutResponseData: any } | null> {
        try {
            if(this.params) {
                const response: any = await getCoachLayouts(this.params!);
                if (response.status === 'ok' && response.answer) {
                    updateRecoilState("coachLayoutResponseAtom", response.answer);
                    return response.answer;
                } else {
                    console.warn("Failed to fetch Data.");
                    return null;
                }
            }
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        }
        return null;
    }
}

export const getCoachLayoutAction = new GetCoachLayoutAction()